<div #wrapper class="skeleton-img-wrapper skeleton">
    <img [src]="src" (load)="onLoad()">
    <div class="overlay"></div>
</div>
